'use client'
import React, { useState, createContext, useContext } from 'react'
import nookies from 'nookies'
import { getDefaultLanguage, getLanguageOptions } from '../languages'
import getSelectedLanguage from '../utils/getSelectedLanguage'
import { useRouter } from 'next/navigation'

const DEFAULT_LANGUAGE = getDefaultLanguage()

// language context with default selected language
export const LanguageContext = createContext({
  language: DEFAULT_LANGUAGE,
  dictionary: {},
})

export const LanguageProvider = ({
  children,
  dictionaryList = {},
  organizationData = {},
}) => {
  const languageOptions = getLanguageOptions(organizationData.config || {})
  const languageContext = useContext(LanguageContext)
  const [language, setLanguage] = useState(languageContext.language)
  const [dictionary, setDictionary] = useState(
    dictionaryList[Object.keys(dictionaryList)[0]]
  )
  const router = useRouter()
  const langSettings = {
    lang: language?.id || 'en',
    dir: language?.id === 'ar' ? 'rtl' : 'ltr',
  }
  const provider = {
    language,
    dictionary,
    languageOptions,
    langSettings,
    setLanguage: async selectedLanguage => {
      const preferredLanguage = await getSelectedLanguage(
        {},
        selectedLanguage.id
      )
      if (language.id !== selectedLanguage.id) {
        setLanguage(selectedLanguage)
        nookies.set(null, 'selectedLanguage', JSON.stringify(selectedLanguage))
        router.refresh();
        window.onload = () => { // check needed to reload the page
          const reloading = sessionStorage.getItem('reloading')
          if (reloading) {
            sessionStorage.removeItem('reloading')
            setDictionary(preferredLanguage[Object.keys(preferredLanguage)[0]])
          }
        }
      }
    },
  }

  return (
    <LanguageContext.Provider value={provider}>
      {children}
    </LanguageContext.Provider>
  )
}
export const LanguageConsumer = LanguageContext.Consumer
